module.exports = __webpack_public_path__ + "static/media/incident_list_logo_2_orange.f334c6d7.png";